import React, { useEffect } from 'react';
import validator from 'utils/json-form/validator';
import Form from '@rjsf/mui';
import type { default as RjsfForm } from '@rjsf/core';
import { AppDispatch, RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { setFormData } from 'reducers/productConfigurationReducer';
import './formStyles.css';
import { transformErrors } from 'utils/json-form/formErrorUtils';
import { DescriptionFieldProps, RJSFSchema, UiSchema } from '@rjsf/utils';
import { getWidgets } from 'utils/json-form/widgets';
import { uiSchema } from 'utils/json-form/formDataUtils';

interface IChangeEvent {
  formData?: Record<string, unknown>;
}

interface ConfigurationFormProps {
  schema: RJSFSchema;
  setIsFormValid?: (valid: boolean) => void;
  propsUiSchema?: UiSchema;
  formValues?: Record<string, unknown>;
}

const ConfigurationForm = ({ schema, setIsFormValid, propsUiSchema, formValues }: ConfigurationFormProps) => {
  const formRef = React.useRef<RjsfForm>(null);
  const dispatch = useDispatch<AppDispatch>();
  const { formData } = useSelector((state: RootState) => state.productConfiguration);

  const handleChange = (e: IChangeEvent) => {
    dispatch(setFormData(e.formData));
  };

  function DescriptionFieldTemplate(props: DescriptionFieldProps) {
    const { description } = props;

    return <div dangerouslySetInnerHTML={{ __html: description.toString() }} />;
  }

  useEffect(() => {
    if (!schema || !formRef?.current || !setIsFormValid) {
      return;
    }
    if (!formData || Object.keys(formData).length === 0) {
      setIsFormValid(false);
      return;
    }

    setIsFormValid(formRef?.current?.state?.schemaValidationErrors?.length === 0);
  }, [formData, formValues, schema, setIsFormValid]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Form
        data-testid="configuration-form"
        schema={schema}
        validator={validator}
        omitExtraData={true}
        liveOmit={true}
        uiSchema={propsUiSchema ? propsUiSchema : uiSchema}
        widgets={getWidgets()}
        onChange={(e) => handleChange(e)}
        formData={formValues ? formValues : formData}
        liveValidate
        transformErrors={transformErrors}
        showErrorList={false}
        ref={formRef}
        templates={{ DescriptionFieldTemplate }}
      >
        {true}
      </Form>
    </Box>
  );
};

export default ConfigurationForm;
